"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionsCheckFunctions = void 0;
const utils_1 = require("./utils");
class ConditionsCheckFunctions {
}
exports.ConditionsCheckFunctions = ConditionsCheckFunctions;
_a = ConditionsCheckFunctions;
ConditionsCheckFunctions.checkStringArray = (targetValue, value) => !value.length || value.some(v => (0, utils_1.compareStrings)(targetValue, v));
ConditionsCheckFunctions.checkString = utils_1.compareStrings;
ConditionsCheckFunctions.checkInContactLists = (_recipient_1, ...args_1) => __awaiter(void 0, [_recipient_1, ...args_1], void 0, function* (_recipient, _ListIds = []) { return false; });
ConditionsCheckFunctions.checkInKeywordLists = (_text_1, ...args_1) => __awaiter(void 0, [_text_1, ...args_1], void 0, function* (_text, _ListIds = []) { return false; });
//# sourceMappingURL=check-functions.js.map